export const SOCIAL_LINKS = [
  {
    href: "https://github.com/voloshyndmitry",
    label: "GitHub",
  },
  {
    href: "https://linkedin.com/in/voloshynd",
    label: "LinkedIn",
  },
  {
    href: "mailto:woloshindima@gmail.com",
    label: "Email",
  },
];
